<template>
  <div class="container">
    <app-header title="物流信息"/>
    <div v-if="logisticsList.length > 0">
      <div class="header1">
        <div class="message">物流状态：<span style="color: red;">{{logisticsList[0].status}}</span></div>
        <div class="message">物流公司：<span>{{logisticsList[0].oddname}}</span></div>
        <div class="message">物流单号：<span>{{logisticsList[0].oddsn}}</span></div>
      </div>
      <van-steps direction="vertical" :active="0">
        <van-step v-for="(item,index) in logisticsList" :key="index">
          <h3>{{item.context}}</h3>
          <p>{{item.time}}</p>
        </van-step>
      </van-steps>
    </div>
    <empty title="暂无订单信息" v-if="logisticsList.length == 0"/>

  </div>
</template>

<script>
    import { queryOrderLogistics } from '@/api/mine/shopProblem.js'
    export default {
        name: "logistics",
        data(){
            return{
               logisticsList : []
            }
        },
        created() {
          this.getDetailInfo()
        },
        methods:{
          getDetailInfo() {
            queryOrderLogistics({id : this.$route.query.orderId}).then(res => {
              if (res.success) {
                this.logisticsList = res.data.logisticsList
              }
            })
          },
        }
    }
</script>

<style lang="less" scoped>
  .container{
    .header1{
      border-bottom: 2px solid #F3F3F3;
      padding-bottom: 15px;
    }
    .message{
      padding-left: 12px;
      padding-right: 12px;
      padding-top: 6px;
      font-size:14px;
      font-family:PingFang SC;
      font-weight:400;
      line-height:20px;
      opacity:1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/mine/refund/logistics.vue